_ = require 'underscore'
tryBabble = require 'app/scripts/lib/try-babble'

tryParseJsonMessage = (str) ->
  try
    JSON.parse(str).message
  catch
    null

module.exports = (resOrString) ->
  message =
    if _.isString(resOrString)
      tryParseJsonMessage(resOrString) || resOrString
    # We used to check for .error, but that wasn't being set consistently
    else if resOrString.responseJSON?.message?
      resOrString.responseJSON.message
    # Maybe we were passed an Error object
    else if resOrString.message?
      tryParseJsonMessage(resOrString.message) || resOrString.message
    else
      resOrString.responseText

  tryBabble(['server error', message]) || message
